import { Link } from "react-router-dom";
import { safetyTitle, safetyText } from "@/mocks/content";

export default function SafetySection() {
  return (
    <section id="safety" className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-50 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wider mb-6">
          <i className="ri-shield-check-line w-3.5 h-3.5 flex items-center justify-center"></i>
          {safetyTitle}
        </div>

        <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
          {safetyText}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/guide/allchinabuy-sheet-complete-guide"
            className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            Read Beginner Guide
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
            Visit Main Website
          </a>
        </div>
      </div>
    </section>
  );
}